import React from "react";
import moment from 'moment';
import { Table, Badge } from "react-bootstrap";
import BagCountSpan from '../../uber-eats/components/BagCountSpan';
import {
  getStatusBackgroundColor,
  formatOrderStatus,
} from "../../uber-eats/utils";
import { formatDeliverooStatus } from "../utils";
import DeliverooRider from "./DeliverooRider";

const DeliverooOrdersTable = ({ orders, centerId }) => {
  return (
    <Table bordered hover size="sm">
      <thead style={{ textAlign: 'center' }}>
        <tr>
          <th colSpan={6} style={{ fontWeight: 'bold', fontSize: '1.7em' }}>
            Commande
          </th>
          <th colSpan={5} style={{ fontWeight: 'bold', fontSize: '1.7em' }}>
            Deliveroo
          </th>
        </tr>
        <tr>
          <th>Date de pickup</th>
          <th>ID</th>
          <th>Client</th>
          <th>Statut</th>
          <th>Emplacement</th>
          <th>Sacs</th>
          <th>Nom de la commande</th>
          <th>Statut Deliveroo</th>
          <th>Nom du livreur</th>
          <th>Num. du livreur</th>
          <th>Statut de livraison</th>
        </tr>
      </thead>
      <tbody>
        {orders.map(o => (
          <tr key={o.id} className={`order-row ${getStatusBackgroundColor(o.order.status)}`}>
            <td>
              {o.pickup_time ? moment(o.pickup_time).format('LLL') : '-'}
              {o.is_scheduled && (
                <Badge variant="info" style={{ marginLeft: '0.5rem' }}>Planifiée</Badge>
              )}
            </td>
            <td>
              <a
                href={`/support/order-with-center/${o.order.id}/center/${centerId}/`}
                target="_blank"
                rel="noopener noreferrer"
              >{o.order.id} (#{o.order.random_id})</a>
            </td>
            <td>
              {o.order.fullname} {o.customer_phone_number || '-'}
            </td>
            <td>
              {formatOrderStatus(o.order.status)}
            </td>
            <td>
              {o.order.transit_area} {o.order.trolley_location ? ` / ${o.order.trolley_location}` : ''}
            </td>
            <td>
              <BagCountSpan order={o.order} />
            </td>
            <td>
              <Badge style={{ backgroundColor: '#00CCBC', color: 'white', marginRight: '0.5rem' }}>Deliveroo</Badge>
              {o.display_id}{o.order_number ? ` (${o.order_number})` : ''}
            </td>
            <td>
              {formatDeliverooStatus(o.deliveroo_status)}
            </td>
            {o.deliveries && o.deliveries.length ? (
              <DeliverooRider deliveries={o.deliveries} />
            ) : <td colSpan={3} style={{ textAlign: 'center' }}>Pas encore de livreur</td>}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default DeliverooOrdersTable;
